const light = Object.freeze({
    primary: '#005799',
    secondary: '#FFCC00',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    logoColor: '#0E0E0E',
    logoFontColor: '#003C79',
    error: '#D10007',
    info: '#81D0F5',
    success: '#A2C510',
    warning: '#F59C05',
})

const dark = Object.freeze({
    primary: '#81D0F5',
    secondary: '#FFE17C',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    logoColor: '#FFFFFF',
    logoFontColor: '#003C79',
    error: '#E88083',
    info: '#D4EDFC',
    success: '#D0E288',
    warning: '#FACD82',
})

const props = Object.freeze({
    headerLogoWidth: 150,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.jpg')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})

